import { NotificationStatus } from '@rapid-recovery-agency-inc/insightt-shared';

export const GET_NOTIFICATION = 'NOTIFICATION/GET_NOTIFICATION';
export const MORE_NOTIFICATION = 'NOTIFICATION/MORE_NOTIFICATION';
export const DELETE_NOTIFICATION = 'NOTIFICATION/DELETE_NOTIFICATION';
export const DELETE_ALL_NOTIFICATION = 'NOTIFICATION/DELETE_ALL_NOTIFICATION';
export const MARK_NOTIFICATION_AS_READ = 'NOTIFICATION/MARK_NOTIFICATION_AS_READ';
export const MARK_ALL_NOTIFICATION_AS_READ = 'NOTIFICATION/MARK_ALL_NOTIFICATION_AS_READ';
export const REFRESH_DATA = 'NOTIFICATION/REFRESH_DATA';

export interface Notification {
  category: string;
  color: string;
  createdAt: string;
  id: number;
  notifyForUser?: {
    avatarUrl?: string;
    firstName?: string;
    lastName?: string;
  };
  notifyForUserId: string | null;
  shiftTimeId: number | null;
  status: NotificationStatus;
  text: string;
  title: string;
  type: string;
  updatedAt: string;
  userId: number;
}

export interface NotificationState {
  currentPage: number;
  notifications: Notification[];
  pageSize: number;
  totalItem: number;
  totalPage: number;
  totalUnread: number;
  isNotificationLoading: boolean;
  isLoadingMoreNotifications: boolean;
  isLoadingOption: boolean;
}
